import { instantsInterceptor, } from '@/api/index';

function getSymbolLibraryList() {
    return instantsInterceptor.get('/service/symbollibrary/list');
}

function updateSymbolLibrary(symbolList) {
    return instantsInterceptor.post('/mgmt/symbollibrary/edit', symbolList);
}

export {
    getSymbolLibraryList,
    updateSymbolLibrary
};